var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Base',{attrs:{"detail":_vm.detail.ruminationLineCustomerInfo || {}}}),_c('Customer',{attrs:{"detail":_vm.detail.ruminationLineCustomerInfo || {}}}),_c('FeedInfo',{attrs:{"detail":_vm.detail || {}}}),_c('CustomerFeedback',{attrs:{"detail":_vm.detail.ruminationLineFeedbackReq || {}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }